export const COMPARE_ENABLED_CONFIG = 'Newbuilding.Compare.Enabled';
export const COMPARE_ONBOARDING_ENABLED_CONFIG = 'Newbuilding.CompareOnboarding.Enabled';
export const COMPARE_FLIGHT_TRAP_ENABLED_CONFIG = 'Newbuilding.CompareFlightTrap.Enabled';
export const COMPARE_FLIGHT_SLIDES_CONFIG = 'Newbuilding.CompareFlightTrap.Slides';
export const COMPARE_ONBOARDING_COOKIE_NAME = 'newbuilding-card-desktop-frontend.compare_onboarding_shown';
export const COMPARE_FLIGHT_UTM_SOURCE = 'compare_flight';
export const SHOW_ONBOARDING_DELAY_MS = 1000;
export const AUTO_CLOSE_ONBOARDING_DELAY_MS = 15000;
export const TRUTHY_COOKIE_CONTENT = '1';
export const COMPARE_BUTTON_DATA_MARK = 'NewbuildingCompareButton';
export const ADD_TO_COMPARE_LABEL = 'Добавить к сравнению';
export const REMOVE_FROM_COMPARE_LABEL = 'Удалить из сравнения';
export const ADD_TO_COMPARE_TEXT = 'В сравнение';
export const REMOVE_FROM_COMPARE_TEXT = 'В сравнении';
export const EMPTY_FLIGHT_SLIDES_ARRAY = [];
